// Texts of "Куда шлём" (UIC-4, docs/design/ui-one-console.md): every
// destination in one table - legs of the console's lines and pushes of
// Flussonic streams - and the saved destination templates.
// Glossary: docs/design/i18n.md ("назначение" - destination, "нога" - leg).

import { defineMessages } from '@/shared/i18n'

export const messages = defineMessages({
  ru: {
    title: 'Куда шлём',
    hint: 'Все места, куда уходит сигнал: ноги линий пульта и пуши потоков Flussonic. Сверху то, что требует внимания.',
    loading: 'Загрузка…',
    loadWhat: 'назначения',
    unavailable: 'Сводка выходов недоступна: control её пока не собирает.',
    flsUnavailable: 'Пуши Flussonic не показаны: {error}',
    wsDown: 'Связь с control потеряна: данные не обновляются. Эфир при этом идёт — агенты работают сами.',

    // tabs and views
    tabsLabel: 'Разделы',
    tabDelivery: 'Доставка',
    tabSaved: 'Сохранённые',
    viewLabel: 'Вид',
    viewTable: 'Таблица',
    viewTiles: 'Плитки',
    viewTilesTitle: 'Плитки с живыми окнами (бывшие «Выходы»)',
    savedHint: 'Бывшие «Цели»: шаблоны назначений. Из них назначение добавляется в поток.',

    // filters
    filterSite: 'Площадка',
    allSites: 'все площадки',
    filterState: 'Состояние',
    stateAll: 'все',
    stateBad: 'проблемы',
    stateOk: 'идут',
    stateIdle: 'сняты / ждут',
    filterOwner: 'Владелец',
    ownerAll: 'все',
    search: 'Поиск',
    searchPlaceholder: 'куда, адрес, поток…',
    resetFilters: 'Сбросить фильтры',
    shown: { one: '{count} назначение', few: '{count} назначения', many: '{count} назначений', other: '{count} назначения' },
    shownOf: '{shown} из {total}',
    empty: 'Под фильтр ничего не попало.',
    emptyAll: 'Назначений нет: ни одна нога линии и ни один пуш Flussonic не заведены.',

    // columns
    colState: 'Состояние',
    colTo: 'Куда',
    colAddress: 'Адрес',
    colFrom: 'Из потока',
    colSite: 'Площадка',
    colActions: 'Действия',

    // legs and pushes
    kindLeg: 'нога линии',
    kindPush: 'пуш Flussonic',
    stAir: 'в эфире',
    stRunning: 'идёт',
    stOff: 'снят',
    stAgentOffline: 'агент не на связи',
    stNotDriven: 'не подаётся',
    stParked: 'подключён, не в эфире',
    stNotConnected: 'нет доставки',
    viaTunnel: 'туннель {name}',
    viaProfile: 'профиль {name}',

    // actions
    toAir: 'В эфир',
    takeOff: 'Снять',
    readOnly: 'только чтение',
    whyModeOff: 'Правка из пульта на этой площадке выключена (agent.yaml).',
    whyBackend: 'Поток завёл бэкенд сайта: из пульта он не меняется.',
    whyOffline: 'Агент площадки не на связи: команда не будет поставлена в очередь.',
    whyRole: 'Нужна роль оператора.',
    legToAirTitle: 'Включить подачу «{channel}» в эфир',
    legOffTitle: 'Снять подачу «{channel}» с эфира',
    pushToAirTitle: 'Включить пуш (запишется на агенте площадки)',
    pushOffTitle: 'Выключить пуш (запишется на агенте площадки)',
    offTitle: 'Снять с эфира',
    offText: 'Подача «{channel}» на «{to}» будет снята с эфира. Если подача покрывает несколько ног линии, снимутся все.',
    actionFailed: 'Не удалось: {error}',
    pushDone: 'Пуш {state}. Ревизия {revision} на агенте.',
    pushStateOn: 'включён',
    pushStateOff: 'выключен',
    errNoPush: 'В документе потока нет пуша №{index}: список изменился, обновите страницу.',
    errPushChanged: 'Пуши потока изменились на агенте: обновите страницу и повторите.',

  },
  en: {
    title: 'Destinations',
    hint: 'Every place the signal goes to: legs of the console lines and pushes of Flussonic streams. What needs attention is on top.',
    loading: 'Loading…',
    loadWhat: 'destinations',
    unavailable: 'The outputs summary is not available: control does not assemble it yet.',
    flsUnavailable: 'Flussonic pushes are not shown: {error}',
    wsDown: 'The link to control is lost: data is not updating. The air keeps running - agents work on their own.',

    tabsLabel: 'Sections',
    tabDelivery: 'Delivery',
    tabSaved: 'Saved',
    viewLabel: 'View',
    viewTable: 'Table',
    viewTiles: 'Tiles',
    viewTilesTitle: 'Tiles with live windows (the former "Outputs")',
    savedHint: 'The former "Targets": destination templates. A destination is added to a stream from them.',

    filterSite: 'Site',
    allSites: 'all sites',
    filterState: 'State',
    stateAll: 'all',
    stateBad: 'problems',
    stateOk: 'running',
    stateIdle: 'off / waiting',
    filterOwner: 'Owner',
    ownerAll: 'all',
    search: 'Search',
    searchPlaceholder: 'to, address, stream…',
    resetFilters: 'Reset filters',
    shown: { one: '{count} destination', other: '{count} destinations' },
    shownOf: '{shown} of {total}',
    empty: 'Nothing matches the filter.',
    emptyAll: 'No destinations: no line leg and no Flussonic push exists.',

    colState: 'State',
    colTo: 'To',
    colAddress: 'Address',
    colFrom: 'From stream',
    colSite: 'Site',
    colActions: 'Actions',

    kindLeg: 'line leg',
    kindPush: 'Flussonic push',
    stAir: 'on air',
    stRunning: 'running',
    stOff: 'off',
    stAgentOffline: 'agent offline',
    stNotDriven: 'not fed',
    stParked: 'connected, not on air',
    stNotConnected: 'not delivering',
    viaTunnel: 'tunnel {name}',
    viaProfile: 'profile {name}',

    toAir: 'Put on air',
    takeOff: 'Take off',
    readOnly: 'read only',
    whyModeOff: 'Editing from the console is off on this site (agent.yaml).',
    whyBackend: "The stream was created by the site's backend: it is not changed from the console.",
    whyOffline: "The site's agent is offline: the command would not be queued.",
    whyRole: 'The operator role is needed.',
    legToAirTitle: 'Put the route "{channel}" on air',
    legOffTitle: 'Take the route "{channel}" off air',
    pushToAirTitle: "Enable the push (written on the site's agent)",
    pushOffTitle: "Disable the push (written on the site's agent)",
    offTitle: 'Take off air',
    offText: 'The route "{channel}" to "{to}" will be taken off air. If the route covers several legs of the line, all of them go.',
    actionFailed: 'Failed: {error}',
    pushDone: 'Push {state}. Revision {revision} on the agent.',
    pushStateOn: 'enabled',
    pushStateOff: 'disabled',
    errNoPush: "The stream's document has no push #{index}: the list changed, reload the page.",
    errPushChanged: 'The pushes of the stream changed on the agent: reload the page and try again.',

  },
})
